// extracted by mini-css-extract-plugin
module.exports = {"main":"_1tqIBgV4mF"};